var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-modal-check"},[_c('b-form-group',{attrs:{"label":_vm.field.is_mandatory && !_vm.field.is_optional
        ? _vm.field.name
        : _vm.field.name + ` ${_vm.$t('common.optionalWithBrackets')}`}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.options,"id":_vm.field.id},on:{"change":_vm.emitUpdate},model:{value:(_vm.checkboxModel.value),callback:function ($$v) {_vm.$set(_vm.checkboxModel, "value", $$v)},expression:"checkboxModel.value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }